const initialState = {
  cancel_policy_list: [],
  error: {
    main: ''
  }
}

export default function main(state = initialState, action){
  switch(action.type) {
  case 'SET_STATE_CANCEL_POLICIES':
    return Object.assign({}, state, action.params)
  case 'ERROR':
    return Object.assign({}, state, { error: Object.assign({}, state.error, { [action.element]: action.message }) })
  default:
    return state
  }
}
